import * as MatchStatus from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { useContext } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import ViewerConditionsGroupActions from './ViewerConditionsGroupActions';
import ViewerConditionsGroupConditions from './ViewerConditionsGroupConditions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerConditionsGroupMatchStatusTag from './ViewerConditionsGroupMatchStatusTag';
import MatchStatusIcon from './MatchStatusIcon';
import styled from 'styled-components';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import FilterGroupLogicGroupToggle from './FilterGroupLogicGroupToggle';
import { hasFlexibleLogicGroupConditions } from '../../permissions/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GroupContainer = styled.div.attrs({
  'data-highlight-target': 'viewer-conditions-group',
  'data-test-id': 'viewer-conditions-group'
})(({
  useOnePanel,
  theme,
  defaultFormat,
  matchFail,
  matchPass
}) => {
  const divStyles = {
    position: 'relative',
    borderRadius: theme.borderRadius[100],
    zIndex: 1
  };
  if (defaultFormat) {
    divStyles.padding = theme.space[300];
    divStyles.backgroundColor = theme.color['fill-tertiary-default'];
  }
  if (useOnePanel) {
    if (matchFail) {
      divStyles.borderLeft = `4px solid ${theme.color['border-alert-default']}`;
      divStyles.paddingLeft = theme.space[200];
    } else if (matchPass) {
      divStyles.borderLeft = `4px solid ${theme.color['fill-positive-default']}`;
      divStyles.paddingLeft = theme.space[200];
    }
  } else {
    if (matchFail) {
      divStyles.backgroundColor = theme.color['fill-alert-subtle'];
    } else if (matchPass) {
      divStyles.backgroundColor = theme.color['fill-positive-subtle'];
    }
  }
  const beforeStyles = {};
  divStyles['&::before'] = beforeStyles;
  if (defaultFormat) {
    beforeStyles.content = '""';
    beforeStyles.position = 'absolute';
    beforeStyles.top = 0;
    beforeStyles.bottom = 0;
    beforeStyles.left = 0;
    beforeStyles.right = 0;
    beforeStyles.border = `1px solid ${theme.color['text-primary-disabled']}`;
    beforeStyles.borderRadius = theme.borderRadius[100];
    beforeStyles.zIndex = -1;
  }
  if (matchFail) {
    beforeStyles.borderColor = theme.color['border-alert-default'];
  } else if (matchPass) {
    beforeStyles.borderColor = theme.color['fill-positive-default'];
  }
  return divStyles;
});
const ViewerConditionsGroup = props => {
  const {
    inputUse,
    logicGroup,
    logicGroupIndex,
    matchStatus: matchStatusFromProps
  } = props;
  const {
    isTestFiltersEnabled
  } = useStrategy();
  const {
    isInEditMode,
    testFiltersStatus,
    props: {
      isAndGroup,
      layout,
      strategy,
      useNarrowPanelFormat,
      useOnePanel,
      canEditLogicGroupConditions = false
    }
  } = useContext(SegmentationFiltersInstanceContext);
  let matchStatus = matchStatusFromProps;
  const logicGroupMatchStatusData = testFiltersStatus && testFiltersStatus.filtersData && testFiltersStatus.filtersData[logicGroupIndex];
  if (isTestFiltersEnabled) {
    matchStatus = logicGroupMatchStatusData && logicGroupMatchStatusData.status;
  }
  const showFilterGroupLogicGroupToggle =
  // has the consuming app opted-in
  canEditLogicGroupConditions &&
  // does the strategy support it (only ILS has supported)
  strategy.canEditLogicGroupCondition && hasFlexibleLogicGroupConditions() && isInEditMode;
  const GroupHeading = /*#__PURE__*/_jsx(H5, {
    marginBlock: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filtersViewer.groupHeading",
      options: {
        groupIndex: logicGroupIndex + 1
      }
    })
  });
  return /*#__PURE__*/_jsxs(GroupContainer, {
    defaultFormat: !useOnePanel && (layout === 'embedded' || !useNarrowPanelFormat),
    matchFail: matchStatus === MatchStatus.FAIL,
    matchPass: matchStatus === MatchStatus.PASS,
    useOnePanel: !!useOnePanel,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: [useOnePanel && isTestFiltersEnabled && /*#__PURE__*/_jsx(Box, {
        paddingInlineStart: "100",
        paddingInlineEnd: "300",
        children: /*#__PURE__*/_jsx(MatchStatusIcon, {
          matchStatus: matchStatus
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          flexGrow: 1
        },
        children: [!isAndGroup && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          marginBlockStart: "-100",
          marginBlockEnd: matchStatus ? '0' : '100',
          minBlockSize: "32px",
          children: [showFilterGroupLogicGroupToggle ? /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "300",
            children: [GroupHeading, /*#__PURE__*/_jsx(FilterGroupLogicGroupToggle, {
              logicGroupIndex: logicGroupIndex
            })]
          }) : GroupHeading, /*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsx(ViewerConditionsGroupActions, {
              logicGroupIndex: logicGroupIndex
            })
          })]
        }), /*#__PURE__*/_jsx(ViewerConditionsGroupMatchStatusTag, {
          matchStatus: matchStatus,
          hideIcon: useOnePanel
        })]
      })]
    }), /*#__PURE__*/_jsx(ViewerConditionsGroupConditions, {
      inputUse: inputUse,
      logicGroup: logicGroup,
      logicGroupIndex: logicGroupIndex,
      logicGroupMatchStatusData: logicGroupMatchStatusData
    })]
  });
};
export default ViewerConditionsGroup;